/**
 * "Pack finder" quiz widget (sections/sis-collection-hero.liquid).
 *
 * Fully driven by theme editor blocks (see the section schema):
 * - First question: BAC / Evaluare Națională & Gimnaziu / Clase Primare.
 * - BAC (`flow: bac`): 4 profiles → subjects → physical/digital formats.
 * - Catalog (`flow: catalog`): category cards (2 for Evaluare Națională,
 *   4 primary classes). Gimnaziu then asks for class (V / VI / VII) before
 *   the final CTA. Evaluare Națională and Primare skip that extra step.
 *
 * Final CTA navigates to the results page (`data-results-url` from the
 * "Pagină rezultate quiz" setting) with quiz answers as query params.
 * If that URL is empty, it falls back to the matching collection URL.
 *
 * Icons: pulled directly from the Figma file's own vector nodes (Figma
 * MCP `download_assets`, exported as SVG) rather than hand-drawn
 * approximations, so they're pixel-exact to the design. Each icon's
 * hardcoded stroke color was swapped for `currentColor` so it still
 * inherits the surrounding text color (e.g. white when a card becomes
 * selected). `graduation-cap`, `star`, `headphones` and `tablet` aren't in
 * the current design — they're hand-drawn fallbacks kept only as extra
 * `icon` select options for profiles/formats merchants might add later.
 */
(function () {
  var ICONS = {
    // Figma node 263:3210 — "icon/Books" (profile: Uman)
    'book-stack':
      '<svg viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M15.625 7.8125H9.375C8.51206 7.8125 7.8125 8.51206 7.8125 9.375V40.625C7.8125 41.4879 8.51206 42.1875 9.375 42.1875H15.625C16.4879 42.1875 17.1875 41.4879 17.1875 40.625V9.375C17.1875 8.51206 16.4879 7.8125 15.625 7.8125Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.8125 15.625H17.1875" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M25 7.8125H18.75C17.8871 7.8125 17.1875 8.51206 17.1875 9.375V40.625C17.1875 41.4879 17.8871 42.1875 18.75 42.1875H25C25.8629 42.1875 26.5625 41.4879 26.5625 40.625V9.375C26.5625 8.51206 25.8629 7.8125 25 7.8125Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.1875 34.375H26.5625" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M34.2844 7.30115L28.2219 8.92615C27.3848 9.15051 26.8881 10.011 27.1125 10.848L35.2375 41.1605C35.4619 41.9976 36.3223 42.4943 37.1594 42.2699L43.2219 40.6449C44.0589 40.4205 44.5556 39.5601 44.3312 38.723L36.2062 8.41052C35.9819 7.57347 35.1214 7.07678 34.2844 7.30115Z" stroke="currentColor" stroke-width="2.00848" stroke-linecap="round" stroke-linejoin="round"/><path d="M33.4375 35L42.5 32.5586" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M28.5938 16.875L37.6563 14.4531" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    // Figma node 263:3222 — "icon / heroicons / Outline / beaker" (profile: Real)
    beaker:
      '<svg viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M40.475 32.142C39.8933 31.5604 39.1525 31.1639 38.3459 31.0026L33.3718 30.0078C30.6461 29.4626 27.8164 29.8416 25.3302 31.0847L24.669 31.4153C22.1827 32.6584 19.3531 33.0373 16.6274 32.4922L12.6029 31.6873C11.2368 31.4141 9.82455 31.8417 8.83945 32.8268M16.6663 8.33331H33.3329L31.2496 10.4166V21.1908C31.2496 22.2958 31.6886 23.3556 32.47 24.137L42.8866 34.5537C45.5115 37.1786 43.6525 41.6666 39.9404 41.6666H10.0588C6.3467 41.6666 4.48768 37.1786 7.11253 34.5537L17.5292 24.137C18.3106 23.3556 18.7496 22.2958 18.7496 21.1908V10.4166L16.6663 8.33331Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    // Figma node 263:3225 — "Feather Icons / settings" (profile: Tehnologic)
    settings:
      '<svg viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M25 31.25C28.4518 31.25 31.25 28.4518 31.25 25C31.25 21.5482 28.4518 18.75 25 18.75C21.5482 18.75 18.75 21.5482 18.75 25C18.75 28.4518 21.5482 31.25 25 31.25Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M40.4167 31.25C40.1394 31.8783 40.0566 32.5754 40.1792 33.2512C40.3017 33.927 40.6239 34.5506 41.1042 35.0416L41.2292 35.1666C41.6166 35.5536 41.9239 36.0132 42.1336 36.519C42.3433 37.0248 42.4512 37.567 42.4512 38.1146C42.4512 38.6621 42.3433 39.2043 42.1336 39.7101C41.9239 40.216 41.6166 40.6755 41.2292 41.0625C40.8422 41.4499 40.3827 41.7572 39.8768 41.9669C39.371 42.1766 38.8288 42.2845 38.2813 42.2845C37.7337 42.2845 37.1915 42.1766 36.6857 41.9669C36.1798 41.7572 35.7203 41.4499 35.3333 41.0625L35.2083 40.9375C34.7173 40.4572 34.0937 40.135 33.4179 40.0125C32.7421 39.8899 32.045 39.9727 31.4167 40.25C30.8005 40.5141 30.275 40.9526 29.9048 41.5115C29.5347 42.0704 29.336 42.7254 29.3333 43.3958V43.75C29.3333 44.855 28.8944 45.9149 28.113 46.6963C27.3316 47.4777 26.2717 47.9166 25.1667 47.9166C24.0616 47.9166 23.0018 47.4777 22.2204 46.6963C21.439 45.9149 21 44.855 21 43.75V43.5625C20.9839 42.8729 20.7607 42.2041 20.3594 41.6431C19.9581 41.0821 19.3974 40.6547 18.75 40.4166C18.1216 40.1393 17.4246 40.0566 16.7488 40.1791C16.073 40.3017 15.4493 40.6239 14.9583 41.1041L14.8333 41.2291C14.4464 41.6165 13.9868 41.9239 13.481 42.1336C12.9752 42.3432 12.433 42.4512 11.8854 42.4512C11.3379 42.4512 10.7957 42.3432 10.2898 42.1336C9.78402 41.9239 9.32448 41.6165 8.93751 41.2291C8.55011 40.8422 8.24278 40.3826 8.03309 39.8768C7.82341 39.371 7.71548 38.8288 7.71548 38.2812C7.71548 37.7337 7.82341 37.1915 8.03309 36.6856C8.24278 36.1798 8.55011 35.7203 8.93751 35.3333L9.06251 35.2083C9.54279 34.7173 9.86498 34.0937 9.98752 33.4179C10.1101 32.742 10.0273 32.045 9.75001 31.4166C9.48592 30.8005 9.04742 30.2749 8.48848 29.9048C7.92954 29.5346 7.27457 29.336 6.60418 29.3333H6.25001C5.14494 29.3333 4.08513 28.8943 3.30373 28.1129C2.52233 27.3315 2.08334 26.2717 2.08334 25.1666C2.08334 24.0616 2.52233 23.0018 3.30373 22.2204C4.08513 21.439 5.14494 21 6.25001 21H6.43751C7.12708 20.9838 7.79585 20.7606 8.35688 20.3594C8.91791 19.9581 9.34525 19.3973 9.58334 18.75C9.86067 18.1216 9.94339 17.4246 9.82085 16.7488C9.69831 16.0729 9.37613 15.4493 8.89584 14.9583L8.77084 14.8333C8.38344 14.4463 8.07611 13.9868 7.86643 13.481C7.65674 12.9752 7.54882 12.433 7.54882 11.8854C7.54882 11.3378 7.65674 10.7956 7.86643 10.2898C8.07611 9.78399 8.38344 9.32445 8.77084 8.93748C9.15781 8.55008 9.61735 8.24275 10.1232 8.03306C10.629 7.82338 11.1712 7.71545 11.7188 7.71545C12.2663 7.71545 12.8085 7.82338 13.3143 8.03306C13.8202 8.24275 14.2797 8.55008 14.6667 8.93748L14.7917 9.06248C15.2827 9.54276 15.9063 9.86495 16.5821 9.98749C17.2579 10.11 17.955 10.0273 18.5833 9.74998H18.75C19.3662 9.48589 19.8917 9.04739 20.2619 8.48845C20.632 7.92951 20.8307 7.27453 20.8333 6.60415V6.24998C20.8333 5.14491 21.2723 4.0851 22.0537 3.3037C22.8351 2.5223 23.8949 2.08331 25 2.08331C26.1051 2.08331 27.1649 2.5223 27.9463 3.3037C28.7277 4.0851 29.1667 5.14491 29.1667 6.24998V6.43748C29.1693 7.10787 29.368 7.76284 29.7381 8.32178C30.1083 8.88072 30.6338 9.31922 31.25 9.58331C31.8784 9.86064 32.5754 9.94336 33.2512 9.82082C33.9271 9.69828 34.5507 9.3761 35.0417 8.89581L35.1667 8.77081C35.5536 8.38341 36.0132 8.07608 36.519 7.8664C37.0248 7.65671 37.567 7.54879 38.1146 7.54879C38.6622 7.54879 39.2044 7.65671 39.7102 7.8664C40.216 8.07608 40.6755 8.38341 41.0625 8.77081C41.4499 9.15778 41.7572 9.61732 41.9669 10.1231C42.1766 10.629 42.2845 11.1712 42.2845 11.7187C42.2845 12.2663 42.1766 12.8085 41.9669 13.3143C41.7572 13.8201 41.4499 14.2797 41.0625 14.6666L40.9375 14.7916C40.4572 15.2826 40.135 15.9063 40.0125 16.5821C39.89 17.2579 39.9727 17.9549 40.25 18.5833V18.75C40.5141 19.3662 40.9526 19.8917 41.5115 20.2618C42.0705 20.632 42.7255 20.8306 43.3958 20.8333H43.75C44.8551 20.8333 45.9149 21.2723 46.6963 22.0537C47.4777 22.8351 47.9167 23.8949 47.9167 25C47.9167 26.105 47.4777 27.1649 46.6963 27.9463C45.9149 28.7277 44.8551 29.1666 43.75 29.1666H43.5625C42.8921 29.1693 42.2371 29.368 41.6782 29.7381C41.1193 30.1083 40.6808 30.6338 40.4167 31.25V31.25Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    // Figma node 263:3230 — "Phosphor Icons / PaintBrush" (profile: Vocațional)
    'paint-brush':
      '<svg viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M3.90625 42.1875H17.9688C19.9775 42.1875 21.9411 41.5919 23.6113 40.4759C25.2814 39.3599 26.5832 37.7737 27.3519 35.9179C28.1206 34.0621 28.3217 32.02 27.9299 30.0499C27.538 28.0797 26.5707 26.2701 25.1503 24.8497C23.7299 23.4293 21.9203 22.462 19.9501 22.0702C17.98 21.6783 15.9379 21.8794 14.0821 22.6481C12.2263 23.4168 10.6401 24.7186 9.52414 26.3887C8.40815 28.0589 7.8125 30.0225 7.8125 32.0313C7.8125 39.0625 3.90625 42.1875 3.90625 42.1875Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M21.9531 22.6953C25.7031 17.6367 35.2344 6.05469 43.9453 6.05469C43.9453 14.7656 32.3633 24.2969 27.3047 28.0469" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M25.9766 17.6953C28.623 19.1889 30.8111 21.377 32.3047 24.0234" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    // Hand-drawn fallback (not in the current Figma design) — extra `icon` option
    'graduation-cap':
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 8.5 12 4l10 4.5-10 4.5-10-4.5Z"/><path d="M6 11v5c0 1.1 2.7 3 6 3s6-1.9 6-3v-5"/><path d="M22 8.5V15"/></svg>',
    // Hand-drawn fallback (not in the current Figma design) — extra `icon` option
    star:
      '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.5l2.9 6.06 6.6.79-4.9 4.6 1.28 6.55L12 17.9l-5.88 2.6 1.28-6.55-4.9-4.6 6.6-.79z"/></svg>',
    // Figma node 263:3273 — "Feather Icons / book-open" (format: Materiale fizice)
    'book-open':
      '<svg viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M4.16675 6.25H16.6667C18.8769 6.25 20.9965 7.12797 22.5593 8.69078C24.1221 10.2536 25.0001 12.3732 25.0001 14.5833V43.75C25.0001 42.0924 24.3416 40.5027 23.1695 39.3306C21.9974 38.1585 20.4077 37.5 18.7501 37.5H4.16675V6.25Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M45.8333 6.25H33.3333C31.1232 6.25 29.0036 7.12797 27.4408 8.69078C25.878 10.2536 25 12.3732 25 14.5833V43.75C25 42.0924 25.6585 40.5027 26.8306 39.3306C28.0027 38.1585 29.5924 37.5 31.25 37.5H45.8333V6.25Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    // Figma node 263:3262 — "Phosphor Icons / Laptop" (format: Materiale digitale)
    laptop:
      '<svg viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M7.8125 34.375V14.0625C7.8125 13.2337 8.14174 12.4388 8.72779 11.8528C9.31384 11.2667 10.1087 10.9375 10.9375 10.9375H39.0625C39.8913 10.9375 40.6862 11.2667 41.2722 11.8528C41.8583 12.4388 42.1875 13.2337 42.1875 14.0625V34.375" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M4.6875 34.375H45.3125V37.5C45.3125 38.3288 44.9833 39.1237 44.3972 39.7097C43.8112 40.2958 43.0163 40.625 42.1875 40.625H7.8125C6.9837 40.625 6.18884 40.2958 5.60279 39.7097C5.01674 39.1237 4.6875 38.3288 4.6875 37.5V34.375Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M28.125 17.1875H21.875" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    // Hand-drawn fallback (not in the current Figma design) — extra `icon` option
    headphones:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 14v-2a9 9 0 0 1 18 0v2"/><rect x="2.5" y="14" width="5" height="6.5" rx="1.5"/><rect x="16.5" y="14" width="5" height="6.5" rx="1.5"/></svg>',
    // Hand-drawn fallback (not in the current Figma design) — extra `icon` option
    tablet:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="2.5" width="16" height="19" rx="2"/><line x1="12" y1="18.2" x2="12.01" y2="18.2"/></svg>',
    // Figma node 117:2404 — "Feather Icons / info" (tooltip trigger + header)
    info:
      '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 16V12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 8H12.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    // Figma node 117:2406 — "Feather Icons / x" (tooltip close button)
    close:
      '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    // Figma node 156:2431 — "icon/arrow-left" (back button)
    'arrow-left':
      '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M19 12H5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 19L5 12L12 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    // Figma node 323:3184 — "icon/arrow-right" (next / final CTA button)
    'arrow-right':
      '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M4.16675 10H15.8334" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M10 4.16669L15.8333 10L10 15.8334" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  function icon(name, className) {
    var markup = ICONS[name];
    if (!markup) return '';
    return '<span class="' + (className || '') + '">' + markup + '</span>';
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : str;
    return div.innerHTML;
  }

  function compact(arr) {
    if (!arr || typeof arr.filter !== 'function') return [];
    return arr.filter(function (item) {
      return item != null;
    });
  }

  function norm(value) {
    return String(value == null ? '' : value)
      .trim()
      .toLowerCase();
  }

  function asArray(value) {
    return Array.isArray(value) ? value : [];
  }

  function closestEl(start, selector) {
    var el = start;
    if (!el) return null;
    if (el.nodeType !== 1) el = el.parentElement;
    while (el && el.nodeType === 1 && typeof el.closest !== 'function') {
      el = el.parentElement;
    }
    if (el && typeof el.closest === 'function') return el.closest(selector);
    while (el && el.nodeType === 1) {
      if (el.matches && el.matches(selector)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function parseSubjectLines(raw, fallback) {
    var fromRaw = [];
    if (typeof raw === 'string' && raw.trim()) {
      raw.split(/\r\n|\n|\r/).forEach(function (line) {
        var parts = line.split('|');
        var label = (parts[0] || '').trim();
        if (!label) return;
        fromRaw.push({
          label: label,
          core: norm(parts[1]) === 'core'
        });
      });
    }
    if (fromRaw.length) return fromRaw;
    return compact(fallback).filter(function (subject) {
      return subject && subject.label;
    });
  }

  function initPackFinder(root) {
    var configEl = root.querySelector('[data-sis-quiz-config]');
    var config = { tracks: [], profiles: [], formats: [], categories: [], items: [] };
    try {
      var raw = configEl
        ? (configEl.tagName === 'TEXTAREA' ? configEl.value : configEl.textContent)
        : '{}';
      config = JSON.parse(raw || '{}');
    } catch (e) {
      config = { tracks: [], profiles: [], formats: [], categories: [], items: [] };
    }
    var tracks = compact(config.tracks);
    var profiles = compact(config.profiles);
    var formats = compact(config.formats);
    profiles.forEach(function (profile) {
      if (!profile) return;
      profile.tag = norm(profile.tag);
      profile.subjects = parseSubjectLines(profile.subjectsRaw, profile.subjects);
    });
    formats.forEach(function (format) {
      if (!format) return;
      format.tag = norm(format.tag || format.format_tag);
      format.tags = compact(format.tags);
      format.tooltipItems = compact(format.tooltipItems);
    });
    if (!tracks.length) {
      tracks = [
        { tag: 'bac', title: 'BAC', flow: 'bac', icon: 'graduation-cap' },
        {
          tag: 'evaluare-nationala',
          title: 'Evaluare Națională & Gimnaziu',
          flow: 'catalog',
          icon: 'book-stack',
          categoryStepLabel: 'Alege categoria',
          itemsStepLabel: 'Tipul de produse'
        },
        {
          tag: 'primare',
          title: 'Clase Primare',
          flow: 'catalog',
          icon: 'star',
          categoryStepLabel: 'Alege clasa',
          itemsStepLabel: 'Alege materialele'
        }
      ];
    }
    var trackByTag = {};
    compact(tracks).forEach(function (track) {
      if (!track) return;
      track.tag = norm(track.tag);
      track.flow = norm(track.flow);
      if (!track.tag) return;
      trackByTag[track.tag] = Object.assign({}, trackByTag[track.tag] || {}, track);
    });
    tracks = [];
    Object.keys(trackByTag).forEach(function (tag) {
      tracks.push(trackByTag[tag]);
    });
    var DEFAULT_CATEGORIES = [
      { track: 'evaluare-nationala', tag: 'gimnaziu', icon: 'book-stack', title: 'Gimnaziu (clasele 5-7)', subtitle: 'Clasele V, VI și VII', childStepLabel: 'Alege clasa' },
      { track: 'evaluare-nationala', tag: 'evaluare', icon: 'graduation-cap', title: 'Evaluare Națională', subtitle: 'Clasa a VIII-a' },
      { track: 'primare', tag: 'clasa-i', icon: 'star', title: 'Clasa I', subtitle: 'Materiale pentru clasa I' },
      { track: 'primare', tag: 'clasa-ii', icon: 'star', title: 'Clasa a II-a', subtitle: 'Materiale pentru clasa a II-a' },
      { track: 'primare', tag: 'clasa-iii', icon: 'star', title: 'Clasa a III-a', subtitle: 'Materiale pentru clasa a III-a' },
      { track: 'primare', tag: 'clasa-iv', icon: 'star', title: 'Clasa a IV-a', subtitle: 'Materiale pentru clasa a IV-a' }
    ];
    var DEFAULT_ITEMS = [
      { categoryKey: 'gimnaziu', tag: 'clasa-v', icon: 'star', title: 'Clasa a Va' },
      { categoryKey: 'gimnaziu', tag: 'clasa-vi', icon: 'star', title: 'Clasa a VIa' },
      { categoryKey: 'gimnaziu', tag: 'clasa-vii', icon: 'star', title: 'Clasa a VIIa' }
    ];
    var categoryMap = {};
    DEFAULT_CATEGORIES.forEach(function (category) {
      categoryMap[category.track + ':' + category.tag] = category;
    });
    compact(config.categories).forEach(function (category) {
      if (!category || !category.tag) return;
      category.tag = norm(category.tag);
      category.track = norm(category.track);
      if (!category.track) {
        category.track = category.tag.indexOf('clasa-') === 0 ? 'primare' : 'evaluare-nationala';
      }
      var key = (category.track || '') + ':' + category.tag;
      categoryMap[key] = Object.assign({}, categoryMap[key] || {}, category);
    });
    var categories = [];
    Object.keys(categoryMap).forEach(function (key) {
      categories.push(categoryMap[key]);
    });
    var itemMap = {};
    DEFAULT_ITEMS.forEach(function (item) {
      itemMap[item.categoryKey + ':' + item.tag] = item;
    });
    compact(config.items).forEach(function (item) {
      if (!item || !item.tag) return;
      item.tag = norm(item.tag);
      item.categoryKey = norm(item.categoryKey);
      if (!item.categoryKey) return;
      var itemKey = item.categoryKey + ':' + item.tag;
      itemMap[itemKey] = Object.assign({}, itemMap[itemKey] || {}, item);
    });
    var items = [];
    Object.keys(itemMap).forEach(function (key) {
      items.push(itemMap[key]);
    });
    if (!profiles.length) {
      profiles = [];
    }

    var stepLabelEl = root.querySelector('[data-sis-quiz-step-label]');
    var progressBar = root.querySelector('[data-sis-quiz-progress-bar]');
    var dotsEl = root.querySelector('[data-sis-quiz-dots]');
    var backRow = root.querySelector('[data-sis-quiz-back-row]');
    var backBtn = root.querySelector('[data-sis-quiz-back]');
    var backProfileEl = root.querySelector('[data-sis-quiz-back-profile]');
    var crumbsEl = root.querySelector('[data-sis-quiz-subject-crumbs]');
    var tracksEl = root.querySelector('[data-sis-quiz-tracks]');
    var profilesEl = root.querySelector('[data-sis-quiz-profiles]');
    var recapCardEl = root.querySelector('[data-sis-quiz-recap-card]');
    var formatsEl = root.querySelector('[data-sis-quiz-formats]');
    var categoriesEl = root.querySelector('[data-sis-quiz-categories]');
    var itemsEl = root.querySelector('[data-sis-quiz-items]');
    var nextBtn = root.querySelector('[data-sis-quiz-next]');
    var timeEl = root.querySelector('[data-sis-quiz-time]');
    var stepEls = {
      tracks: root.querySelector('[data-sis-quiz-step="tracks"]'),
      profiles: root.querySelector('[data-sis-quiz-step="profiles"]'),
      subjects: root.querySelector('[data-sis-quiz-step="subjects"]'),
      formats: root.querySelector('[data-sis-quiz-step="formats"]'),
      categories: root.querySelector('[data-sis-quiz-step="categories"]'),
      items: root.querySelector('[data-sis-quiz-step="items"]'),
      materials: root.querySelector('[data-sis-quiz-step="materials"]')
    };
    var materialsEl = root.querySelector('[data-sis-quiz-materials]');

    // Static back-button icon (arrow-left), rendered once.
    var backIconEl = backBtn && backBtn.querySelector('[data-sis-quiz-back-icon]');
    if (backIconEl) backIconEl.innerHTML = ICONS['arrow-left'];

    var labels = {
      track: root.getAttribute('data-track-label') || 'Ce pregătești',
      trackTime: root.getAttribute('data-track-time') || '5 secunde',
      step1: root.getAttribute('data-step1-label') || '',
      step2: root.getAttribute('data-step2-label') || '',
      step3: root.getAttribute('data-step3-label') || '',
      time1: root.getAttribute('data-step1-time') || '',
      time2: root.getAttribute('data-step2-time') || '',
      time3: root.getAttribute('data-step3-time') || '',
      back: root.getAttribute('data-back-label') || 'Înapoi',
      next: root.getAttribute('data-next-label') || 'Mai departe',
      finalCta: root.getAttribute('data-final-cta-label') || 'Vezi pachetul ideal'
    };

    var state = {
      step: 'tracks',
      track: null,
      profile: null,
      subjects: {},
      format: null,
      category: null,
      item: null,
      materials: {}
    };

    function bacTrack() {
      var found = null;
      tracks.forEach(function (track) {
        if (track && (norm(track.tag) === 'bac' || norm(track.flow) === 'bac')) found = track;
      });
      return found || { tag: 'bac', title: 'BAC', flow: 'bac' };
    }

    function isBacFlow(track) {
      if (!track) return false;
      return norm(track.flow) === 'bac' || norm(track.tag) === 'bac';
    }

    function currentFlow() {
      if (!state.track) return ['tracks'];
      if (isBacFlow(state.track)) return ['tracks', 'profiles', 'subjects', 'formats'];
      var flow = ['tracks', 'categories'];
      if (state.category && itemsForCategory().length) flow.push('items');
      else if (isEvaluareCategory(state.category)) flow.push('materials');
      return flow;
    }

    function stepIndex() {
      var flow = currentFlow();
      var index = flow.indexOf(state.step);
      return index < 0 ? 0 : index;
    }

    function categoriesForTrack() {
      if (!state.track) return [];
      var tag = norm(state.track.tag);
      var matched = categories.filter(function (category) {
        return category && norm(category.track) === tag;
      });
      if (matched.length) return matched;
      if (tag === 'primare' || tag.indexOf('primar') !== -1) {
        matched = categories.filter(function (category) {
          var trackTag = norm(category.track);
          var itemTag = norm(category.tag);
          return trackTag === 'primare' || itemTag.indexOf('clasa-') === 0;
        });
      } else if (tag && tag !== 'bac') {
        matched = categories.filter(function (category) {
          var trackTag = norm(category.track);
          var itemTag = norm(category.tag);
          return (
            trackTag === 'evaluare-nationala' ||
            itemTag === 'gimnaziu' ||
            itemTag === 'evaluare'
          );
        });
      }
      return matched;
    }

    function itemsForCategory() {
      if (!state.category) return [];
      var categoryTag = norm(state.category.tag);
      return items.filter(function (item) {
        return item && norm(item.categoryKey) === categoryTag;
      });
    }

    function renderAnswerCards(container, records, selected, onSelect) {
      if (!container) return;
      container.innerHTML = '';
      asArray(records).forEach(function (record) {
        if (!record) return;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'sis-quiz__answer';
        btn.setAttribute('data-sis-choice', record.tag || '');
        if (selected && selected.tag === record.tag) btn.classList.add('is-selected');
        btn.innerHTML =
          icon(record.icon, 'sis-quiz__answer-icon') +
          '<span><span class="sis-quiz__answer-title">' +
          escapeHtml(record.title) +
          '</span>' +
          (record.subtitle
            ? '<span class="sis-quiz__answer-subtitle">' + escapeHtml(record.subtitle) + '</span>'
            : '') +
          '</span>';
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          onSelect(record);
        });
        container.appendChild(btn);
      });
    }

    function ensureTracksStep() {
      if (stepEls.tracks && tracksEl) return;
      var wrap = document.createElement('div');
      wrap.className = 'sis-quiz__step';
      wrap.setAttribute('data-sis-quiz-step', 'tracks');
      var inner = document.createElement('div');
      inner.className = 'sis-quiz__answers sis-quiz__tracks';
      inner.setAttribute('data-sis-quiz-tracks', '');
      wrap.appendChild(inner);
      var profilesStep = stepEls.profiles;
      var host = (profilesStep && profilesStep.parentNode) || root.querySelector('.sis-quiz__card');
      if (host && profilesStep) host.insertBefore(wrap, profilesStep);
      else if (host) host.appendChild(wrap);
      stepEls.tracks = wrap;
      tracksEl = inner;
    }

    function bindTrackButtons() {
      if (!tracksEl) return;
      tracksEl.onclick = function (event) {
        var btn = closestEl(event.target, '[data-track-tag]');
        if (!btn || !tracksEl.contains(btn)) return;
        var tag = norm(btn.getAttribute('data-track-tag'));
        var flow = norm(btn.getAttribute('data-track-flow'));
        var track = null;
        tracks.forEach(function (candidate) {
          if (candidate && norm(candidate.tag) === tag) track = candidate;
        });
        if (!track) {
          track = {
            tag: tag,
            title: (btn.textContent || '').trim(),
            flow: flow || (tag === 'bac' ? 'bac' : 'catalog')
          };
          tracks.push(track);
        } else if (flow) {
          track.flow = flow;
        }
        if (!track.tag) track.tag = tag;
        selectTrack(track);
      };
    }

    function renderTracks() {
      if (!tracksEl) return;
      var existing = tracksEl.querySelectorAll('[data-track-tag]');
      if (!existing.length) {
        tracks.forEach(function (track) {
          if (!track || !track.title) return;
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'sis-quiz__answer sis-quiz__track';
          btn.setAttribute('data-track-tag', track.tag || '');
          btn.setAttribute('data-track-flow', track.flow || '');
          btn.setAttribute('data-track-icon', track.icon || '');
          btn.innerHTML =
            icon(track.icon, 'sis-quiz__track-icon') +
            '<span><span class="sis-quiz__answer-title">' + escapeHtml(track.title) + '</span></span>';
          tracksEl.appendChild(btn);
        });
        existing = tracksEl.querySelectorAll('[data-track-tag]');
      }
      Array.prototype.forEach.call(existing, function (btn) {
        var tag = norm(btn.getAttribute('data-track-tag'));
        var track = null;
        tracks.forEach(function (candidate) {
          if (candidate && norm(candidate.tag) === tag) track = candidate;
        });
        var iconName = btn.getAttribute('data-track-icon') || (track && track.icon) || '';
        if (iconName && !btn.querySelector('.sis-quiz__track-icon')) {
          btn.insertAdjacentHTML('afterbegin', icon(iconName, 'sis-quiz__track-icon'));
        }
        btn.classList.toggle('is-selected', !!(state.track && norm(state.track.tag) === tag));
      });
      bindTrackButtons();
    }

    function selectTrack(track) {
      state.track = track;
      state.profile = null;
      state.subjects = {};
      state.format = null;
      state.category = null;
      state.item = null;
      if (isBacFlow(track)) {
        goToStep('profiles');
      } else {
        goToStep('categories');
      }
    }

    function renderProfiles() {
      renderAnswerCards(profilesEl, profiles, state.profile, selectProfile);
    }

    function renderCategories() {
      var records = categoriesForTrack();
      if (!records.length && state.track) {
        var tag = norm(state.track.tag);
        records = DEFAULT_CATEGORIES.filter(function (category) {
          return category.track === tag || (tag !== 'bac' && tag !== 'primare' && category.track === 'evaluare-nationala') || ((tag === 'primare' || tag.indexOf('primar') !== -1) && category.track === 'primare');
        });
      }
      renderAnswerCards(categoriesEl, records, state.category, selectCategory);
    }

    function renderItems() {
      renderAnswerCards(itemsEl, itemsForCategory(), state.item, selectItem);
    }

    function selectProfile(profile) {
      if (!state.track) state.track = bacTrack();
      state.profile = profile;
      state.subjects = {};
      asArray(profile && profile.subjects).forEach(function (subject) {
        if (!subject || !subject.label) return;
        state.subjects[subject.label] = !!subject.core;
      });
      goToStep('subjects');
    }

    function isEvaluareCategory(category) {
      return !!(category && norm(category.tag) === 'evaluare');
    }

    var MATERIAL_OPTIONS = [
      { id: 'flash', label: 'Flashcard-uri' },
      { id: 'manual', label: 'Manuale' },
      { id: 'caiet', label: 'Caiete de exerciții' }
    ];

    function ensureMaterialsStep() {
      var card = root.querySelector('.sis-quiz__card');
      if (!card) return null;
      var step = root.querySelector('[data-sis-quiz-step="materials"]');
      if (!step) {
        step = document.createElement('div');
        step.className = 'sis-quiz__step';
        step.setAttribute('data-sis-quiz-step', 'materials');
        var actions = card.querySelector('.sis-quiz__actions');
        if (actions) card.insertBefore(step, actions);
        else card.appendChild(step);
      }
      var list = step.querySelector('[data-sis-quiz-materials]');
      if (!list) {
        var prompt = document.createElement('p');
        prompt.className = 'sis-quiz__materials-prompt';
        prompt.textContent = 'Poți alege una sau mai multe';
        step.appendChild(prompt);
        list = document.createElement('div');
        list.className = 'sis-quiz__answers';
        list.setAttribute('data-sis-quiz-materials', '');
        step.appendChild(list);
      }
      if (!list.querySelector('[data-material]')) {
        MATERIAL_OPTIONS.forEach(function (option) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'sis-quiz__answer';
          btn.setAttribute('data-material', option.id);
          btn.setAttribute('aria-pressed', 'false');
          btn.innerHTML =
            '<span><span class="sis-quiz__answer-title">' + escapeHtml(option.label) + '</span></span>';
          list.appendChild(btn);
        });
      }
      stepEls.materials = step;
      materialsEl = list;
      return step;
    }

    function renderMaterials() {
      ensureMaterialsStep();
      if (!materialsEl) return;
      materialsEl.querySelectorAll('[data-material]').forEach(function (btn) {
        var id = btn.getAttribute('data-material');
        var on = !!state.materials[id];
        btn.classList.toggle('is-selected', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (btn.getAttribute('data-bound') === '1') return;
        btn.setAttribute('data-bound', '1');
        btn.addEventListener('click', function () {
          state.materials[id] = !state.materials[id];
          var selected = !!state.materials[id];
          btn.classList.toggle('is-selected', selected);
          btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
          updateNextButton();
        });
      });
    }

    function selectCategory(category) {
      state.category = category;
      state.item = null;
      state.materials = {};
      if (itemsForCategory().length) {
        goToStep('items');
        return;
      }
      renderCategories();
      updateNextButton();
    }

    function selectItem(item) {
      state.item = item;
      renderItems();
      updateNextButton();
    }

    function renderRecapCard() {
      if (!state.profile) return;
      if (!recapCardEl) recapCardEl = root.querySelector('[data-sis-quiz-recap-card]');
      if (!recapCardEl) return;
      var profile = state.profile;
      var subjectsHtml = asArray(profile.subjects)
        .map(function (subject) {
          if (!subject || !subject.label) return '';
          var selected = !!state.subjects[subject.label];
          return (
            '<button type="button" class="sis-quiz__subject-pill' +
            (selected ? ' is-selected' : '') +
            '" data-subject="' +
            encodeURIComponent(subject.label) +
            '">' +
            escapeHtml(subject.label) +
            '</button>'
          );
        })
        .join('');

      recapCardEl.innerHTML =
        icon(profile.icon, 'sis-quiz__recap-icon') +
        '<div>' +
        '<p class="sis-quiz__recap-title">' +
        escapeHtml(profile.title) +
        '</p>' +
        (profile.subtitle ? '<p class="sis-quiz__recap-subtitle">' + escapeHtml(profile.subtitle) + '</p>' : '') +
        '<div class="sis-quiz__subjects">' +
        subjectsHtml +
        '</div>' +
        '<p class="sis-quiz__subject-prompt">Selectează-ți toate materiile</p>' +
        '</div>';

      recapCardEl.querySelectorAll('[data-subject]').forEach(function (pill, index) {
        if (pill.animate) {
          pill.animate(
            [
              { opacity: 0, transform: 'translateY(10px) scale(0.82)' },
              { opacity: 1, transform: 'translateY(-3px) scale(1.06)', offset: 0.55 },
              { opacity: 1, transform: 'translateY(0) scale(1)' }
            ],
            {
              duration: 320,
              delay: 40 + index * 45,
              easing: 'cubic-bezier(0.2, 0.85, 0.2, 1)',
              fill: 'backwards'
            }
          );
        }
        pill.addEventListener('click', function () {
          var label = decodeURIComponent(pill.getAttribute('data-subject'));
          state.subjects[label] = !state.subjects[label];
          pill.classList.toggle('is-selected', !!state.subjects[label]);
        });
      });
    }

    function renderFormats() {
      if (!formatsEl) return;
      formatsEl.innerHTML = '';
      formats.forEach(function (format) {
        // A plain <div role="button"> (not a real <button>) because the
        // tooltip below needs its own trigger + close <button>s, and
        // buttons can't be nested inside buttons.
        var card = document.createElement('div');
        card.className = 'sis-quiz__format-card';
        card.setAttribute('role', 'button');
        card.setAttribute('tabindex', '0');
        var isSelected = !!(state.format && state.format.tag === format.tag);
        card.classList.toggle('is-selected', isSelected);
        card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');

        var tagsHtml = (format.tags || [])
          .map(function (tag) {
            return '<span class="sis-quiz__format-tag">' + escapeHtml(tag) + '</span>';
          })
          .join('');

        var tooltipHtml = '';
        if (format.tooltipTitle || (format.tooltipItems && format.tooltipItems.length)) {
          var itemsHtml = (format.tooltipItems || [])
            .map(function (item) {
              return (
                '<li>' +
                (item.term ? '<strong>' + escapeHtml(item.term) + '</strong> ' : '') +
                escapeHtml(item.description) +
                '</li>'
              );
            })
            .join('');

          tooltipHtml =
            '<span class="sis-tooltip">' +
            '<button type="button" class="sis-tooltip__trigger" aria-haspopup="dialog" aria-expanded="false" aria-label="Informații despre ' +
            escapeHtml(format.title) +
            '">' + icon('info') + '</button>' +
            '<div class="sis-tooltip__bubble" role="dialog" aria-label="' + escapeHtml(format.tooltipTitle || '') + '">' +
            '<div class="sis-tooltip__bubble-head">' +
            icon('info', 'sis-tooltip__bubble-icon') +
            '<p class="sis-tooltip__bubble-title">' + escapeHtml(format.tooltipTitle) + '</p>' +
            '<button type="button" class="sis-tooltip__bubble-close" aria-label="Închide">' + icon('close') + '</button>' +
            '</div>' +
            '<ul class="sis-tooltip__bubble-list">' + itemsHtml + '</ul>' +
            '</div>' +
            '</span>';
        }

        card.innerHTML =
          '<span class="sis-quiz__format-head">' +
          '<span class="sis-quiz__format-title">' +
          icon(format.icon, 'sis-quiz__format-icon') +
          '<span class="sis-quiz__format-title-text">' + escapeHtml(format.title) + '</span>' +
          '</span>' +
          tooltipHtml +
          '</span>' +
          '<span class="sis-quiz__format-tags">' + tagsHtml + '</span>';

        function selectThisFormat() {
          state.format = format;
          renderFormats();
          updateNextButton();
        }

        card.addEventListener('click', function (event) {
          // Ignore clicks inside the tooltip so opening/closing the info
          // popover doesn't also toggle format selection.
          if (event.target.closest('.sis-tooltip')) return;
          selectThisFormat();
        });
        card.addEventListener('keydown', function (event) {
          if (event.target.closest('.sis-tooltip')) return;
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            selectThisFormat();
          }
        });

        var tooltipEl = card.querySelector('.sis-tooltip');
        if (tooltipEl) initTooltip(tooltipEl);

        formatsEl.appendChild(card);
      });
    }

    function openTooltip(tooltipEl) {
      root.querySelectorAll('.sis-tooltip.is-open').forEach(function (other) {
        if (other !== tooltipEl) closeTooltip(other);
      });
      tooltipEl.classList.add('is-open');
      var trigger = tooltipEl.querySelector('.sis-tooltip__trigger');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }

    function closeTooltip(tooltipEl) {
      tooltipEl.classList.remove('is-open');
      var trigger = tooltipEl.querySelector('.sis-tooltip__trigger');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }

    function initTooltip(tooltipEl) {
      var trigger = tooltipEl.querySelector('.sis-tooltip__trigger');
      var closeBtn = tooltipEl.querySelector('.sis-tooltip__bubble-close');

      trigger.addEventListener('mouseenter', function () {
        openTooltip(tooltipEl);
      });
      tooltipEl.addEventListener('mouseleave', function () {
        closeTooltip(tooltipEl);
      });
      trigger.addEventListener('focus', function () {
        openTooltip(tooltipEl);
      });
      trigger.addEventListener('click', function (event) {
        event.stopPropagation();
        if (tooltipEl.classList.contains('is-open')) {
          closeTooltip(tooltipEl);
        } else {
          openTooltip(tooltipEl);
        }
      });
      if (closeBtn) {
        closeBtn.addEventListener('click', function (event) {
          event.stopPropagation();
          closeTooltip(tooltipEl);
        });
      }
    }

    function updateBackRow() {
      var index = stepIndex();
      if (backRow) backRow.hidden = index === 0;
      var backTitle = '';
      if (state.step === 'profiles' || state.step === 'categories') {
        backTitle = state.track ? state.track.title : '';
      } else if (state.step === 'subjects' || state.step === 'formats') {
        backTitle = state.profile ? state.profile.title : '';
      } else if (state.step === 'items') {
        backTitle = state.category ? state.category.title : '';
      }
      if (backProfileEl) backProfileEl.textContent = backTitle;
      if (!crumbsEl) return;

      var selectedSubjects = Object.keys(state.subjects).filter(function (label) {
        return state.subjects[label];
      });
      if (state.step === 'formats' && selectedSubjects.length) {
        crumbsEl.hidden = false;
        crumbsEl.textContent = selectedSubjects.join(' • ');
      } else if (state.step === 'items' && state.category) {
        crumbsEl.hidden = false;
        crumbsEl.textContent = state.category.title;
      } else if (state.step === 'materials' && state.category) {
        crumbsEl.hidden = false;
        crumbsEl.textContent = state.category.title;
      } else {
        crumbsEl.hidden = true;
      }
    }

    function updateNextButton() {
      if (!nextBtn) return;
      if (state.step === 'tracks' || state.step === 'profiles') {
        nextBtn.hidden = true;
        return;
      }
      nextBtn.hidden = false;
      if (state.step === 'subjects') {
        nextBtn.innerHTML = '<span>' + escapeHtml(labels.next) + '</span>' + icon('arrow-right', 'sis-btn__icon');
        nextBtn.disabled = false;
        return;
      }
      if (
        state.step === 'categories' &&
        (itemsForCategory().length || isEvaluareCategory(state.category))
      ) {
        nextBtn.innerHTML = '<span>' + escapeHtml(labels.next) + '</span>' + icon('arrow-right', 'sis-btn__icon');
        nextBtn.disabled = !state.category;
        return;
      }
      nextBtn.innerHTML = '<span>' + escapeHtml(labels.finalCta) + '</span>' + icon('arrow-right', 'sis-btn__icon');
      if (state.step === 'formats') {
        nextBtn.disabled = !state.format;
      } else if (state.step === 'materials') {
        nextBtn.disabled = !MATERIAL_OPTIONS.some(function (option) {
          return state.materials[option.id];
        });
      } else if (state.step === 'categories') {
        nextBtn.disabled = !state.category;
      } else if (state.step === 'items') {
        nextBtn.disabled = !state.item;
      }
    }

    function stepMeta(step) {
      if (step === 'tracks') return { label: labels.track, time: labels.trackTime };
      if (step === 'profiles') return { label: labels.step1, time: labels.time1 };
      if (step === 'subjects') return { label: labels.step2, time: labels.time2 };
      if (step === 'formats') return { label: labels.step3, time: labels.time3 };
      if (step === 'materials') return { label: 'Tipul de materiale', time: '8 secunde' };
      if (step === 'categories') {
        return {
          label: (state.track && state.track.categoryStepLabel) || 'Alege categoria',
          time: (state.track && state.track.categoryStepTime) || '8 secunde'
        };
      }
      if (step === 'items') {
        return {
          label:
            (state.category && state.category.childStepLabel) ||
            (state.track && state.track.itemsStepLabel) ||
            'Alege clasa',
          time: (state.track && state.track.itemsStepTime) || '8 secunde'
        };
      }
      return {
        label: (state.track && state.track.itemsStepLabel) || 'Tipul de produse',
        time: (state.track && state.track.itemsStepTime) || '8 secunde'
      };
    }

    function renderDots(flow, index) {
      if (!dotsEl) return;
      dotsEl.innerHTML = '';
      flow.forEach(function (_, i) {
        var dot = document.createElement('span');
        dot.className = 'sis-quiz__dot';
        if (i === index) dot.classList.add('is-active');
        if (i < index) dot.classList.add('is-done');
        dotsEl.appendChild(dot);
      });
    }

    function goToStep(step) {
      if (!state.track && step !== 'tracks') {
        step = 'tracks';
      }
      state.step = step;
      if (step === 'materials') ensureMaterialsStep();
      Object.keys(stepEls).forEach(function (key) {
        var el = stepEls[key];
        if (!el) return;
        var active = key === step;
        if (active) {
          el.removeAttribute('hidden');
          el.style.setProperty('display', 'block', 'important');
        } else {
          el.setAttribute('hidden', '');
          el.style.removeProperty('display');
        }
        el.classList.toggle('is-active', active);
      });

      var flow = currentFlow();
      var index = stepIndex();
      var total = flow.length;
      var meta = stepMeta(step);
      var stepLabelText = state.track
        ? 'Pasul ' + (index + 1) + ' din ' + total
        : 'Pasul 1';
      if (meta.label) stepLabelText += ' • ' + meta.label;
      if (stepLabelEl) stepLabelEl.textContent = stepLabelText;
      if (progressBar) {
        var progressTotal = state.track ? total : 2;
        progressBar.style.width = ((index + 1) / progressTotal) * 100 + '%';
      }
      renderDots(flow, index);
      if (timeEl) timeEl.textContent = meta.time;

      try {
        if (step === 'tracks') renderTracks();
        if (step === 'profiles') renderProfiles();
        if (step === 'subjects') renderRecapCard();
        if (step === 'formats') renderFormats();
        if (step === 'categories') renderCategories();
        if (step === 'items') renderItems();
        if (step === 'materials') renderMaterials();
      } catch (err) {
        if (typeof console !== 'undefined' && console.error) {
          console.error('SIS pack finder step render failed', step, err);
        }
      }

      updateBackRow();
      updateNextButton();
    }

    function goToPrevStep() {
      var flow = currentFlow();
      var index = stepIndex();
      if (index <= 0) return;
      var prev = flow[index - 1];
      if (prev === 'tracks') {
        state.profile = null;
        state.subjects = {};
        state.format = null;
        state.category = null;
        state.item = null;
      }
      goToStep(prev);
    }

    function handleNext() {
      if (state.step === 'subjects') {
        goToStep('formats');
      } else if (state.step === 'formats' && state.format) {
        submitResult();
      } else if (state.step === 'categories' && state.category) {
        if (itemsForCategory().length) {
          goToStep('items');
        } else if (isEvaluareCategory(state.category)) {
          goToStep('materials');
        } else {
          submitResult();
        }
      } else if (state.step === 'items' && state.item) {
        submitResult();
      } else if (state.step === 'materials') {
        var picked = MATERIAL_OPTIONS.filter(function (option) {
          return state.materials[option.id];
        });
        if (picked.length) submitResult();
      }
    }

    function submitResult() {
      var resultsUrl = (root.getAttribute('data-results-url') || '').trim();
      var url = resultsUrl;
      var params = new URLSearchParams();

      if (state.track && state.track.tag) params.set('sis_track', state.track.tag);

      if (state.track && !isBacFlow(state.track)) {
        if (!url && state.item && state.item.url) url = state.item.url;
        if (!url && state.category && state.category.url) url = state.category.url;
        if (!url) return;
        if (state.category && state.category.tag) params.set('sis_category', state.category.tag);
        if (state.item && state.item.tag) params.set('sis_class', state.item.tag);
        if (isEvaluareCategory(state.category)) {
          var materialIds = MATERIAL_OPTIONS.filter(function (option) {
            return state.materials[option.id];
          }).map(function (option) {
            return option.id;
          });
          if (materialIds.length) params.set('sis_materials', materialIds.join(','));
        }
      } else {
        if (!state.profile) return;
        if (!url) url = state.profile.url || '';
        if (!url) return;
        if (state.profile.tag) params.set('sis_profile', state.profile.tag);
        var selectedSubjects = [];
        if (state.profile.subjects && state.profile.subjects.length) {
          state.profile.subjects.forEach(function (subject) {
            if (subject && subject.label && state.subjects[subject.label]) {
              selectedSubjects.push(subject.label);
            }
          });
        } else {
          selectedSubjects = Object.keys(state.subjects).filter(function (label) {
            return state.subjects[label];
          });
        }
        if (selectedSubjects.length) params.set('sis_subjects', selectedSubjects.join(','));
        if (state.format && state.format.tag) params.set('sis_format', state.format.tag);
      }

      params.set('sis_r', String(Date.now()));
      var query = params.toString();
      var nextUrl = query ? url + (url.indexOf('?') > -1 ? '&' : '?') + query : url;
      try {
        history.pushState({ sisQuiz: 1 }, '', window.location.href);
      } catch (e) {}
      window.location.assign(nextUrl);
    }

    if (backBtn) backBtn.addEventListener('click', goToPrevStep);
    if (nextBtn) nextBtn.addEventListener('click', handleNext);

    document.addEventListener('click', function (event) {
      root.querySelectorAll('.sis-tooltip.is-open').forEach(function (tooltipEl) {
        if (!tooltipEl.contains(event.target)) closeTooltip(tooltipEl);
      });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        root.querySelectorAll('.sis-tooltip.is-open').forEach(closeTooltip);
      }
    });

    ensureTracksStep();
    goToStep('tracks');
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-sis-pack-finder]');
    roots.forEach(function (root) {
      if (root.getAttribute('data-sis-ready')) return;
      root.setAttribute('data-sis-ready', 'true');
      try {
        initPackFinder(root);
      } catch (e) {
        root.removeAttribute('data-sis-ready');
        if (typeof console !== 'undefined' && console.error) {
          console.error('SIS pack finder failed to start', e);
        }
      }
    });
  }

  window.addEventListener('pageshow', function (event) {
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (!event.persisted && !(nav && nav.type === 'back_forward')) return;
    try {
      history.pushState({ sisQuiz: 1 }, '', window.location.href);
    } catch (e) {}
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var sectionRoot = event.target;
    if (!sectionRoot) return;
    var widget = sectionRoot.matches('[data-sis-pack-finder]')
      ? sectionRoot
      : sectionRoot.querySelector('[data-sis-pack-finder]');
    if (widget) widget.removeAttribute('data-sis-ready');
    boot(sectionRoot);
  });
})();
